
const Shippers = (state) => state.Shippers;
const Shipper = (state) => state.Shipper;
export default { Shipper, Shippers }